import React from 'react'

import { useNavigation } from '@zet/common/hooks/useNavigation'
import { BTN_LG } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { i18n } from '@zet/localization'

const EditButton = () => {
  const { navigate } = useNavigation()
  return (
    <Pressable onPress={() => navigate('AddBankAccount', { fromEdit: true })}>
      <BTN_LG className="text-primary-100">
        {i18n.t('accountDetails.editDetails')}
      </BTN_LG>
    </Pressable>
  )
}

export default EditButton
